import { InlineSpinner } from "components/InlineSpinner";
import { LyneBoardPicker } from "components/Lyne/LyneBoardPicker";
import { LyneButton } from "components/Lyne/LyneButton";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { BoardLookup } from "models/BoardLookup";
import { ResourceKeys, useBoardSettings, useTranslations } from "providers";
import React from "react";

import { useBoardSendTo } from "../useBoardSendTo";
import { SendToTable } from "./SendToTable";

export const BoardSendToPanel: React.FC = () => {
  const i18n = useTranslations();
  const { boardId } = useBoardSettings();
  const { results, closePanel, addOutgoing, addIncoming, remove, deletingId, isLoading } = useBoardSendTo();

  if (!boardId) return null;

  const outgoing = results?.outgoing ?? [];
  const incoming = results?.incoming ?? [];

  return (
    <SlidingPanel
      isOpen={true}
      onCancel={closePanel}
      onClose={closePanel}
      header={<h1>{i18n.SendToTargets}</h1>}
      footer={
        <LyneButton onClick={closePanel} kind="ghost">
          {i18n.Actions_Close}
        </LyneButton>
      }
    >
      {isLoading && <InlineSpinner />}
      {!isLoading && (
        <>
          {/* Outgoing */}
          <h5 className="mb-2">
            <i className="bi bi-box-arrow-right me-2" />
            {i18n.SendTo_Outgoing}
            <small className="text-muted"> ({outgoing.length})</small>
          </h5>

          <SendToTable
            items={outgoing}
            getDisplayBoard={(item) => item.target}
            deletingId={deletingId}
            onRemove={remove}
          />

          <div className="mt-3 mb-5">
            <LyneBoardPicker
              name="send-to-outgoing-picker"
              boardId={boardId}
              permission="CanView"
              onSelect={(board: BoardLookup) => addOutgoing(board.id)}
              label={ResourceKeys.SendTo_AddOutgoing}
              contextHelp={undefined}
            />
          </div>

          {/* Incoming */}
          <h5 className="mb-2">
            <i className="bi bi-box-arrow-in-right me-2" />
            {i18n.SendTo_Incoming}
            <small className="text-muted"> ({incoming.length})</small>
          </h5>

          <SendToTable
            items={incoming}
            getDisplayBoard={(item) => item.board}
            deletingId={deletingId}
            onRemove={remove}
          />

          <div className="mt-3">
            <LyneBoardPicker
              name="send-to-incoming-picker"
              label={ResourceKeys.SendTo_AddIncoming}
              boardId={boardId}
              permission="CanEdit"
              onSelect={(board: BoardLookup) => addIncoming(board.id)}
              contextHelp={undefined}
            />
          </div>
        </>
      )}
    </SlidingPanel>
  );
};
